<template>
<div class="crud">
  <the-crud :title="title" :store="store" :columns="columns" :search="search" :canDelete="true">
  </the-crud>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import TheCrud from '@/components/crud/TheCrud'
export default {
  components : {
    TheCrud
  },
  data() {
    return {
      closeModal : true,
      server : null,
      confirmationValue: '',
      confirmationMessage: '',
      title : this.$t("configuration.servers.mediacenter.title"),
      store : 'mediaservers',
      search : ['name','janusSipServer'],
      columns : [
        { index : 'id', label : '#id', sortable : true},
        { index : 'name', label : this.$t('configuration.servers.name') },
        { index : 'janusSipServer', label : this.$t('configuration.servers.mediacenter.sip_server') },
        { index : 'janusSipServerPassword', label : this.$t('configuration.servers.mediacenter.sip_password'), 'hide in table': true },
      ],
    }
  },
  computed : {
    ...mapGetters(['isAdmin']),
  }
}
</script>

<style>

</style>